import React from "react";
import Input, { InputProps } from "./Element/Input";

export interface FieldSearchProps {
    inputProps: InputProps;
}

const FieldSearch: React.FC<FieldSearchProps> = ({ inputProps }) => {
    return (
        <React.Fragment>
            <label htmlFor="search-bar-input" className="search-bar__label icon-search"></label>
            <Input {...inputProps} />
        </React.Fragment>
    );
};

export default FieldSearch;
